import { CacheProvider } from '@emotion/react'
import { ThemeProvider } from '@mui/material/styles';
import { CustomTheme, cacheRtl } from 'assets/theme/CustomTheme';
import React, { useEffect, useState } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import MyRouter from 'router/MyRouter'
import { WbContextProvider } from 'services/context/MainContext'
import "react-toastify/dist/ReactToastify.css";
import PWAInstaller from 'services/installer/PwaInstaller';

export default function App() {

    const [installer, setInstaller] = useState(false)

    return (
        <>
            <WbContextProvider>
                <CacheProvider value={cacheRtl}>
                    <ThemeProvider theme={CustomTheme}>
                        <BrowserRouter>
                            <MyRouter installer={installer} setInstaller={setInstaller} />
                            <ToastContainer
                                position="top-center"
                                autoClose={3000}
                                hideProgressBar={false}
                                newestOnTop={false}
                                closeOnClick
                                rtl={true}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                                theme="light"
                            />
                            <PWAInstaller promptNew={installer} setPromptNew={setInstaller} />
                        </BrowserRouter>
                    </ThemeProvider>
                </CacheProvider>
            </WbContextProvider>
        </>
    )
}
